module.exports = __webpack_public_path__ + "img/FotoMo7.2498fec0.png";